import React, { useState } from 'react';
import EyeIcon from '../../img/inline/EyeIcon.tsx';
import '../../scss/components/PasswordInput.scss';

interface PasswordInputProps {
    onChange?:any,
    onKeyDown?:any,
    placeholder?:string,
    value?:string,
    name:string,
    disabled?:boolean,
    className?:string,
    wrapperClassName?:string,
    required?:boolean,
    label?:string,
    labelPosition?:string,
    showToggle?:boolean,
    ariaLabel?:string,
    autocomplete?:string,
    help?:string,
};

const PasswordInput = ({
    onChange,
    onKeyDown,
    placeholder,
    value,
    name,
    disabled,
    className,
    wrapperClassName,
    required,
    label,
    labelPosition = 'before',
    showToggle = true,
    ariaLabel,
    autocomplete,
    help
}:PasswordInputProps) => {
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <div className={`form-group password-input${help && help.length > 0 ? ' has-helptext' : ''}${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            { label && label.length > 0 && labelPosition === 'before' ? (
                <label htmlFor={name}>{label} {required ? '*' : ''}</label>
            ) : <></>}
            <div className="password-input-wrapper">
                <input
                    type={passwordVisible ? 'text' : 'password'}
                    name={name}
                    id={name}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    className={className}
                    aria-required={required ? 'true' : 'false'}
                    aria-label={ariaLabel ? ariaLabel : (label ? label + (required ? ' (Erforderlich)' : '') : placeholder + (required ? ' (Erforderlich)' : ''))}
                    autoComplete={autocomplete}
                />
                { showToggle ? (
                    <EyeIcon
                        open={passwordVisible}
                        onClick={() => setPasswordVisible(!passwordVisible)}
                    />
                ) : ''}
                { help && help.length > 0 ? (
                    <p className='help-text'><em>{help}</em></p>
                ) : ''}
            </div>
            { label && label.length > 0 && labelPosition === 'after' ? (
                <label htmlFor={name}>{label} {required ? '*' : ''}</label>
            ) : <></>}
        </div>
    )
}

export default PasswordInput;
